"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ORIENTATION_TYPES = exports.LISTBOX_SELECTOR_POSITIONS = exports.LISTBOX_SELECTION_TYPES = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _flat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flat"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _arrFlatten = _interopRequireDefault(require("arr-flatten"));
var _isPrintableKeyEvent = _interopRequireDefault(require("is-printable-key-event"));
var _reactInfiniteScrollHook = _interopRequireDefault(require("react-infinite-scroll-hook"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _isFunction = _interopRequireDefault(require("../utils/isFunction"));
var _useKeyStrokes2 = _interopRequireDefault(require("../utils/useKeyStrokes"));
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _descendantManager = _interopRequireDefault(require("../utils/descendantManager"));
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _listOptions = require("../utils/_listOptions");
var _constants = require("../utils/constants");
var _BusyIndicator = _interopRequireDefault(require("../BusyIndicator/BusyIndicator"));
var _ListboxGroup = _interopRequireDefault(require("./_ListboxGroup"));
var _ListboxItem = _interopRequireDefault(require("./_ListboxItem"));
var _ListContext = _interopRequireDefault(require("./_ListContext"));
var _listboxUtils = require("./_listboxUtils");
var _Listbox = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Listbox.css") : void 0);
var _excluded = ["ariaLabelledby", "bordered", "className", "groupLabelRenderer", "groupProps", "hideOuterFocusRing", "infinite", "ignoreFirstAndLastKeys", "itemKey", "itemText", "label", "labelProps", "listItemRenderer", "listItemProps", "maxHeight", "noDataContent", "onBlur", "onChange", "onFocus", "onKeyDown", "onSelect", "onSelectionChange", "options", "orientation", "pagingStepValue", "selectedKey", "selectedKeys", "selectionFollowsFocus", "selectorPosition", "selectionType", "size", "stickyLabel", "topAlign"];
/* eslint-disable react/no-array-index-key */
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty2(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-listbox';
var ID_SEPARATOR = '-_-_-';
var LISTBOX_SELECTION_TYPES = exports.LISTBOX_SELECTION_TYPES = ['singleSelectMaster',
// used to pick one item with no additional indicator
'singleSelectLeft',
// used to pick one item using a radio button
'multiSelect' // used to pick several items from the list using checkboxes on the far left
];
var ORIENTATION_TYPES = exports.ORIENTATION_TYPES = ['horizontal', 'vertical'];
var LISTBOX_SELECTOR_POSITIONS = exports.LISTBOX_SELECTOR_POSITIONS = ['top-start', 'top-center', 'top-end', 'middle-start', 'middle-end', 'bottom-start', 'bottom-center', 'bottom-end'];

/**
 * The **Listbox** component is an alternative to a **List** that should
 * be used when the ability to select items is required.
 */
var Listbox = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _listOfOptions$, _context7, _context8;
  var ariaLabelledby = props.ariaLabelledby,
    bordered = props.bordered,
    className = props.className,
    groupLabelRenderer = props.groupLabelRenderer,
    groupProps = props.groupProps,
    hideOuterFocusRing = props.hideOuterFocusRing,
    infinite = props.infinite,
    ignoreFirstAndLastKeys = props.ignoreFirstAndLastKeys,
    _props$itemKey = props.itemKey,
    itemKey = _props$itemKey === void 0 ? 'key' : _props$itemKey,
    _props$itemText = props.itemText,
    itemText = _props$itemText === void 0 ? 'text' : _props$itemText,
    label = props.label,
    labelProps = props.labelProps,
    _props$listItemRender = props.listItemRenderer,
    listItemRenderer = _props$listItemRender === void 0 ? 'text' : _props$listItemRender,
    listItemProps = props.listItemProps,
    maxHeight = props.maxHeight,
    noDataContent = props.noDataContent,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onKeyDown = props.onKeyDown,
    onSelect = props.onSelect,
    onSelectionChange = props.onSelectionChange,
    options = props.options,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? 'vertical' : _props$orientation,
    _props$pagingStepValu = props.pagingStepValue,
    pagingStepValue = _props$pagingStepValu === void 0 ? 5 : _props$pagingStepValu,
    selectedKey = props.selectedKey,
    selectedKeys = props.selectedKeys,
    selectionFollowsFocus = props.selectionFollowsFocus,
    _props$selectorPositi = props.selectorPosition,
    selectorPosition = _props$selectorPositi === void 0 ? 'middle-start' : _props$selectorPositi,
    _props$selectionType = props.selectionType,
    selectionType = _props$selectionType === void 0 ? 'singleSelectMaster' : _props$selectionType,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    stickyLabel = props.stickyLabel,
    topAlign = props.topAlign,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var listOfOptions = options || [];
  var isEmpty = listOfOptions.length === 0;
  var isUsingGroups = !isEmpty && Array.isArray(listOfOptions[0]);
  var isMultiSelect = selectionType === 'multiSelect';
  var _useState = (0, _react.useState)(selectedKey),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedOptionKey = _useState2[0],
    setSelectedOptionKey = _useState2[1];
  var _useState3 = (0, _react.useState)(selectedKeys),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    multiSelectedOptionKeys = _useState4[0],
    setMultiSelectedOptionKeys = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    labelHeight = _useState6[0],
    setLabelHeight = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    groupLabelHeight = _useState8[0],
    setGroupLabelHeight = _useState8[1];
  var labelRef = (0, _react.useRef)(null);
  var groupLabelRef = (0, _react.useRef)(null);
  var findFirstNotDisabled = function findFirstNotDisabled(items) {
    return (0, _find.default)(items).call(items, function (option) {
      return option.disabled !== true;
    });
  };
  var firstNonDisabledOptionKey = isUsingGroups ? (0, _listboxUtils.reduceOption)(findFirstNotDisabled(listOfOptions[0]), itemKey) : (0, _listboxUtils.reduceOption)(findFirstNotDisabled(listOfOptions), itemKey);
  var firstFocusableOptionKey = isUsingGroups ? (0, _listboxUtils.reduceOption)((_listOfOptions$ = listOfOptions[0]) === null || _listOfOptions$ === void 0 ? void 0 : _listOfOptions$[0], itemKey) : (0, _listboxUtils.reduceOption)(listOfOptions === null || listOfOptions === void 0 ? void 0 : listOfOptions[0], itemKey);
  var lastOptionGroup = listOfOptions[listOfOptions.length - 1];
  var lastOptionKey = isUsingGroups ? (0, _listboxUtils.reduceOption)(lastOptionGroup[lastOptionGroup.length - 1], itemKey) : (0, _listboxUtils.reduceOption)(lastOptionGroup, itemKey);
  var totalOptions = 0;
  if (isUsingGroups) {
    totalOptions = listOfOptions.reduce(function (prev, curr) {
      return prev + ((curr === null || curr === void 0 ? void 0 : curr.length) || 0);
    }, 0);
  } else {
    totalOptions = listOfOptions === null || listOfOptions === void 0 ? void 0 : listOfOptions.length;
  }
  var _useState9 = (0, _react.useState)(),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    activeKeys = _useState10[0],
    setActiveKeys = _useState10[1];
  var _useState11 = (0, _react.useState)(),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    descendantManager = _useState12[0],
    setDescendantManager = _useState12[1];
  var classnames = _bind.default.bind(_Listbox.default);
  var labelId = (0, _useUniqueId.default)();
  var listIdPrefix = (0, _useUniqueId.default)();
  var listboxRef = (0, _react.useRef)();
  var getId = function getId(key, groupIndex) {
    var _context, _context2, _context3, _context4;
    return (0, _concat.default)(_context = (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(listIdPrefix)).call(_context4, ID_SEPARATOR)).call(_context3, key)).call(_context2, ID_SEPARATOR)).call(_context, groupIndex);
  };
  var getIdFromKeys = function getIdFromKeys() {
    return getId(activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key, activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.groupIndex);
  };
  var getIdUsingOption = function getIdUsingOption(option, groupIndex) {
    return getId((0, _listboxUtils.reduceOption)(option, itemKey), groupIndex);
  };
  var isOptionActive = function isOptionActive(option, groupIndex) {
    var _reduceOption, _activeKeys$key;
    return ((_reduceOption = (0, _listboxUtils.reduceOption)(option, itemKey)) === null || _reduceOption === void 0 ? void 0 : _reduceOption.toString()) === (activeKeys === null || activeKeys === void 0 || (_activeKeys$key = activeKeys.key) === null || _activeKeys$key === void 0 ? void 0 : _activeKeys$key.toString()) && groupIndex === (activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.groupIndex);
  };
  var isOptionSelected = function isOptionSelected(option) {
    var _reduceOption2;
    var optionKey = (_reduceOption2 = (0, _listboxUtils.reduceOption)(option, itemKey)) === null || _reduceOption2 === void 0 ? void 0 : _reduceOption2.toString();
    if (isMultiSelect) {
      return multiSelectedOptionKeys === null || multiSelectedOptionKeys === void 0 ? void 0 : multiSelectedOptionKeys.some(function (key) {
        return key === optionKey;
      });
    }
    return optionKey === selectedOptionKey;
  };
  var parseKeyAndGroupIndex = function parseKeyAndGroupIndex(node) {
    var nodeId = (node === null || node === void 0 ? void 0 : node.id) || '';
    var idTokens = nodeId.split(ID_SEPARATOR);
    return {
      nodeKey: idTokens === null || idTokens === void 0 ? void 0 : idTokens[1],
      groupIndex: parseInt(idTokens === null || idTokens === void 0 ? void 0 : idTokens[2], 10)
    };
  };
  var _getSelectedOption = function _getSelectedOption(keyValue) {
    return (0, _listOptions.getSelectedOption)(isUsingGroups ? (0, _arrFlatten.default)(listOfOptions) : listOfOptions, itemKey, keyValue);
  };
  var getInitiallyFocused = function getInitiallyFocused() {
    var initiallyFocusedKey = selectedOptionKey || (multiSelectedOptionKeys === null || multiSelectedOptionKeys === void 0 ? void 0 : multiSelectedOptionKeys[0]) || selectedKey || (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys[0]) || firstFocusableOptionKey;
    var initiallyFocusedGroupIndex = isUsingGroups ? (0, _findIndex.default)(options).call(options, function (group) {
      return group.some(function (option) {
        return (0, _listboxUtils.reduceOption)(option, itemKey) === initiallyFocusedKey;
      });
    }) : 0;
    return {
      initiallyFocusedKey: initiallyFocusedKey,
      initiallyFocusedGroupIndex: initiallyFocusedGroupIndex
    };
  };
  var findKeystrokeMatchIndex = function findKeystrokeMatchIndex(typedString) {
    if (!typedString || !Array.isArray(options)) {
      return null;
    }
    var findMatch = function findMatch(option) {
      var _reduceOption3;
      var optionText = (_reduceOption3 = (0, _listboxUtils.reduceOption)(option, itemText)) === null || _reduceOption3 === void 0 ? void 0 : (0, _trim.default)(_reduceOption3).call(_reduceOption3);
      return optionText && (typedString === null || typedString === void 0 ? void 0 : (0, _trim.default)(typedString).call(typedString)) && (0, _listboxUtils.matcherMethodIgnoreCase)(optionText, typedString);
    };
    var flatOptions = isUsingGroups ? (0, _flat.default)(options).call(options) : options;
    var filteredOptions = (0, _filter.default)(flatOptions).call(flatOptions, function (option) {
      return !(option !== null && option !== void 0 && option.divider);
    });
    return (0, _findIndex.default)(filteredOptions).call(filteredOptions, findMatch);
  };
  var _useKeyStrokes = (0, _useKeyStrokes2.default)({
      onKeyStrokes: function onKeyStrokes(typedString) {
        var foundIndex = findKeystrokeMatchIndex(typedString);
        var nodes = descendantManager === null || descendantManager === void 0 ? void 0 : descendantManager.getDescendantNodes();
        if (nodes !== null && nodes !== void 0 && nodes.length) {
          descendantManager === null || descendantManager === void 0 || descendantManager.setActiveDescendant(undefined, nodes[foundIndex]);
        }
      }
    }),
    keyStrokes = _useKeyStrokes.keyStrokes,
    setKeyStrokes = _useKeyStrokes.setKeyStrokes;
  var onActiveDescendantChange = function onActiveDescendantChange(e, node, prNode) {
    var _parseKeyAndGroupInde = parseKeyAndGroupIndex(node),
      nodeKey = _parseKeyAndGroupInde.nodeKey,
      groupIndex = _parseKeyAndGroupInde.groupIndex;
    var prevNode = parseKeyAndGroupIndex(prNode);
    if (!isMultiSelect && selectionFollowsFocus) {
      var nodeOption = _getSelectedOption(nodeKey);
      var prevNodeOption = _getSelectedOption(prevNode === null || prevNode === void 0 ? void 0 : prevNode.nodeKey);
      if (nodeKey !== selectedOptionKey && typeof onChange === 'function') {
        onChange(e, nodeOption.disabled ? undefined : nodeKey, nodeOption.disabled ? undefined : nodeOption, prevNodeOption !== null && prevNodeOption !== void 0 && prevNodeOption.disabled ? undefined : prevNode === null || prevNode === void 0 ? void 0 : prevNode.nodeKey, prevNodeOption !== null && prevNodeOption !== void 0 && prevNodeOption.disabled ? undefined : prevNodeOption);
      }
      if (typeof onSelect === 'function' && !(nodeOption !== null && nodeOption !== void 0 && nodeOption.disabled)) {
        onSelect(e, nodeKey, nodeOption);
      }
      setSelectedOptionKey(nodeOption !== null && nodeOption !== void 0 && nodeOption.disabled ? null : nodeKey);
    }
    setActiveKeys({
      key: nodeKey,
      groupIndex: groupIndex
    });
  };
  var handleSelectionChange = function handleSelectionChange(event, node, wasSelected) {
    var _parseKeyAndGroupInde2 = parseKeyAndGroupIndex(node),
      nodeKey = _parseKeyAndGroupInde2.nodeKey;
    if (isMultiSelect) {
      if (wasSelected) {
        // remove from state array
        setMultiSelectedOptionKeys(function (oldArray) {
          return oldArray === null || oldArray === void 0 ? void 0 : (0, _filter.default)(oldArray).call(oldArray, function (key) {
            return key !== nodeKey;
          });
        });
      } else {
        // add to state array
        setMultiSelectedOptionKeys(function (oldArray) {
          var _context5;
          return (0, _concat.default)(_context5 = []).call(_context5, (0, _toConsumableArray2.default)(oldArray), [nodeKey]);
        });
      }
      if (typeof onSelectionChange === 'function') {
        onSelectionChange(event, nodeKey, !wasSelected, _getSelectedOption(nodeKey));
      }
    } else {
      // fire onChange only if selection changes
      if (nodeKey !== selectedOptionKey) {
        if (typeof onChange === 'function') {
          onChange(event, nodeKey, _getSelectedOption(nodeKey), selectedOptionKey, _getSelectedOption(selectedOptionKey));
        }
        setSelectedOptionKey(nodeKey);
      }
      // fire onSelect for every selection event
      if (typeof onSelect === 'function') {
        onSelect(event, nodeKey, _getSelectedOption(nodeKey));
      }
    }
  };
  var handleItemClick = function handleItemClick(e, node, wasSelected) {
    var _listboxRef$current;
    var _parseKeyAndGroupInde3 = parseKeyAndGroupIndex(node),
      nodeKey = _parseKeyAndGroupInde3.nodeKey,
      groupIndex = _parseKeyAndGroupInde3.groupIndex;
    listboxRef === null || listboxRef === void 0 || (_listboxRef$current = listboxRef.current) === null || _listboxRef$current === void 0 || _listboxRef$current.focus({
      preventScroll: true
    });
    handleSelectionChange(e, node, wasSelected);
    setActiveKeys({
      key: nodeKey,
      groupIndex: groupIndex
    });
  };
  var handleOnKeyDown = function handleOnKeyDown(event) {
    var _descendantManager$ac, _descendantManager$ac2, _descendantManager$ac4;
    var nodeDisabledValue = descendantManager === null || descendantManager === void 0 || (_descendantManager$ac = descendantManager.activeDescendant) === null || _descendantManager$ac === void 0 || (_descendantManager$ac2 = _descendantManager$ac.getAttribute) === null || _descendantManager$ac2 === void 0 ? void 0 : _descendantManager$ac2.call(_descendantManager$ac, 'aria-disabled');
    var nodeDisabled = typeof nodeDisabledValue === 'string' && nodeDisabledValue.toLowerCase() === 'true';
    switch ((0, _keycode.default)(event)) {
      case 'space':
        event.preventDefault();
        if (keyStrokes) {
          setKeyStrokes("".concat(keyStrokes, " "));
        } else {
          var _descendantManager$ac3;
          if (nodeDisabled) {
            break;
          }
          handleItemClick(event, descendantManager === null || descendantManager === void 0 ? void 0 : descendantManager.activeDescendant, (descendantManager === null || descendantManager === void 0 || (_descendantManager$ac3 = descendantManager.activeDescendant) === null || _descendantManager$ac3 === void 0 ? void 0 : _descendantManager$ac3.ariaSelected) === 'true');
        }
        break;
      case 'enter':
        if (nodeDisabled) {
          break;
        }
        handleItemClick(event, descendantManager === null || descendantManager === void 0 ? void 0 : descendantManager.activeDescendant, (descendantManager === null || descendantManager === void 0 || (_descendantManager$ac4 = descendantManager.activeDescendant) === null || _descendantManager$ac4 === void 0 ? void 0 : _descendantManager$ac4.ariaSelected) === 'true');
        break;
      default:
        if (
        // if control/command key is pressed, don't add to keyStrokes
        // eg. Crl+C, Cmd+C
        !event.ctrlKey && !event.metaKey && (0, _isPrintableKeyEvent.default)(event)) {
          event.stopPropagation();
          setKeyStrokes(keyStrokes + (0, _keycode.default)(event));
        }
        break;
    }
    if (typeof onKeyDown === 'function') {
      onKeyDown(event, activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key, _getSelectedOption(activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key));
    }
  };
  var getActiveDescendantNode = function getActiveDescendantNode() {
    return document.getElementById(getIdFromKeys());
  };
  var attachDescendantManager = function attachDescendantManager() {
    if (listboxRef !== null && listboxRef !== void 0 && listboxRef.current && !descendantManager) {
      setDescendantManager(new _descendantManager.default({
        trapNode: listboxRef === null || listboxRef === void 0 ? void 0 : listboxRef.current,
        getDescendantNodes: function getDescendantNodes() {
          var _listboxRef$current2;
          return (0, _slice.default)(Array.prototype).call(listboxRef === null || listboxRef === void 0 || (_listboxRef$current2 = listboxRef.current) === null || _listboxRef$current2 === void 0 ? void 0 : _listboxRef$current2.querySelectorAll('li[role="option"]'));
        },
        getActiveDescendantNode: getActiveDescendantNode,
        onActiveDescendantChange: onActiveDescendantChange,
        ignoreFirstAndLastKeys: ignoreFirstAndLastKeys,
        stepValue: pagingStepValue,
        nextKeyCode: orientation === 'horizontal' ? [_keycode.default.codes.right, _keycode.default.codes.down] : _keycode.default.codes.down,
        previousKeyCode: orientation === 'horizontal' ? [_keycode.default.codes.left, _keycode.default.codes.up] : _keycode.default.codes.up
      }));
    }
  };
  var handleFocus = function handleFocus(event) {
    var _getInitiallyFocused = getInitiallyFocused(),
      initiallyFocusedKey = _getInitiallyFocused.initiallyFocusedKey,
      initiallyFocusedGroupIndex = _getInitiallyFocused.initiallyFocusedGroupIndex;
    setActiveKeys({
      key: initiallyFocusedKey,
      groupIndex: initiallyFocusedGroupIndex
    });
    if (typeof onFocus === 'function') {
      onFocus(event);
    }
  };
  var handleBlur = function handleBlur(event) {
    setActiveKeys();
    if (typeof onBlur === 'function') {
      onBlur(event);
    }
  };

  // Scroll to active node if it is not in view.
  // If it is the first or last node, scroll to the beginning or end
  // of the listbox
  var scrollToActive = function scrollToActive(activeNode, isFirstOrLast) {
    if (!activeNode || !listboxRef.current) return;
    var stickyOffset = 0;
    if (stickyLabel) stickyOffset = labelHeight;
    if (isUsingGroups && groupLabelHeight) stickyOffset += groupLabelHeight;

    // an active node exists so let's scroll appropriately
    // added a 5px buffer to account for nodes not being completely
    // in view when scrolled
    if (orientation === 'horizontal') {
      var activeNodeRight = activeNode.offsetLeft + activeNode.offsetWidth + 5;
      var listboxRight = listboxRef.current.scrollLeft + listboxRef.current.offsetWidth;
      if (activeNode.offsetLeft - stickyOffset <= listboxRef.current.scrollLeft) {
        if (isFirstOrLast) {
          listboxRef.current.scrollLeft = 0;
        } else {
          listboxRef.current.scrollLeft = activeNode.offsetLeft - stickyOffset;
        }
      } else if (activeNodeRight >= listboxRight) {
        if (isFirstOrLast) {
          listboxRef.current.scrollLeft = activeNodeRight;
        } else {
          listboxRef.current.scrollLeft = activeNodeRight - listboxRef.current.offsetWidth;
        }
      }
    } else {
      var activeNodeBottom = activeNode.offsetTop + activeNode.offsetHeight + 5;
      var listboxBottom = listboxRef.current.scrollTop + listboxRef.current.offsetHeight;
      if (activeNode.offsetTop - stickyOffset <= listboxRef.current.scrollTop) {
        if (isFirstOrLast) {
          listboxRef.current.scrollTop = 0;
        } else {
          listboxRef.current.scrollTop = activeNode.offsetTop - stickyOffset;
        }
      } else if (activeNodeBottom >= listboxBottom) {
        if (isFirstOrLast) {
          listboxRef.current.scrollTop = activeNodeBottom;
        } else {
          listboxRef.current.scrollTop = activeNodeBottom - listboxRef.current.offsetHeight;
        }
      }
    }
  };
  var externalListContextValue = (0, _react.useContext)(_ListContext.default) || {};
  var listContextValue = {
    bordered: bordered,
    isUsingGroups: isUsingGroups,
    selectionType: selectionType,
    size: size,
    orientation: orientation
  };
  (0, _useUniversalLayoutEffect.default)(function () {
    if (stickyLabel) {
      var _labelRef$current, _groupLabelRef$curren;
      var dimension = orientation === 'vertical' ? 'clientHeight' : 'clientWidth';
      setLabelHeight(labelRef === null || labelRef === void 0 || (_labelRef$current = labelRef.current) === null || _labelRef$current === void 0 ? void 0 : _labelRef$current[dimension]);
      setGroupLabelHeight(groupLabelRef === null || groupLabelRef === void 0 || (_groupLabelRef$curren = groupLabelRef.current) === null || _groupLabelRef$curren === void 0 ? void 0 : _groupLabelRef$curren[dimension]);
    }
  }, [orientation, stickyLabel]);
  (0, _react.useEffect)(function () {
    setSelectedOptionKey(selectedKey);
  }, [selectedKey]);
  (0, _react.useEffect)(function () {
    var keys = selectedKeys || [];
    if (!Array.isArray(multiSelectedOptionKeys) || !(0, _listOptions.haveSameKeys)(keys, multiSelectedOptionKeys)) {
      setMultiSelectedOptionKeys(keys);
    }
  }, [selectedKeys]);
  (0, _react.useEffect)(function () {
    if (!activeKeys) {
      descendantManager === null || descendantManager === void 0 || descendantManager.detach();
      setDescendantManager();
      return;
    }
    if (!isMultiSelect && selectionFollowsFocus && !selectedOptionKey) {
      var selectedOption = _getSelectedOption(activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key);
      setSelectedOptionKey(selectedOption !== null && selectedOption !== void 0 && selectedOption.disabled ? undefined : activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key);
      if (typeof onSelect === 'function' && !selectedOption.disabled) {
        onSelect(undefined, activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key, selectedOption);
      }
      if (typeof onChange === 'function' && !selectedOption.disabled) {
        onChange(undefined, activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key, selectedOption, undefined, undefined);
      }
    }
    attachDescendantManager();
    var activeNode = document.getElementById(getIdFromKeys());
    var isFirstOrLast = (activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key) === firstNonDisabledOptionKey || (activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key) === lastOptionKey;
    scrollToActive(activeNode, isFirstOrLast);
    descendantManager === null || descendantManager === void 0 || descendantManager.updateActiveDescendant(function () {
      return document.getElementById(getIdFromKeys());
    });
  }, [activeKeys]);
  (0, _react.useEffect)(function () {
    if (options) {
      var _getInitiallyFocused2 = getInitiallyFocused(),
        initiallyFocusedKey = _getInitiallyFocused2.initiallyFocusedKey,
        initiallyFocusedGroupIndex = _getInitiallyFocused2.initiallyFocusedGroupIndex;
      var activeNode = document.getElementById(getId(initiallyFocusedKey, initiallyFocusedGroupIndex));
      var isFirstOrLast = initiallyFocusedKey === firstNonDisabledOptionKey || initiallyFocusedKey === lastOptionKey;
      scrollToActive(activeNode, isFirstOrLast);
    }
  }, []);
  var renderGroupLabel = function renderGroupLabel(group) {
    var _groupData$;
    var groupData = group;
    if (!Array.isArray(group)) {
      groupData = [group];
    }
    return (0, _isFunction.default)(groupLabelRenderer) ? groupLabelRenderer(groupData) : (_groupData$ = groupData[0]) === null || _groupData$ === void 0 ? void 0 : _groupData$[groupLabelRenderer];
  };
  var posInSet = 0;
  var sizeOfSet;
  if (infinite) {
    sizeOfSet = infinite.hasMore ? -1 : totalOptions;
  }
  var renderItem = function renderItem(item, itemIndex, groupIndex) {
    var _item$attributes, _externalListContextV, _context6;
    posInSet += 1;

    // allow pre-selected disabled items in multiSelect mode
    var allowSelection = selectionType === 'multiSelect' || !(item !== null && item !== void 0 && item.disabled);
    return /*#__PURE__*/_react.default.createElement(_ListboxItem.default, (0, _extends2.default)({}, listItemProps, item === null || item === void 0 ? void 0 : item.attributes, {
      selectorPosition: selectorPosition,
      className: classnames(listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.className, item === null || item === void 0 || (_item$attributes = item.attributes) === null || _item$attributes === void 0 ? void 0 : _item$attributes.className, externalListContextValue === null || externalListContextValue === void 0 || (_externalListContextV = externalListContextValue.optionTypeClassName) === null || _externalListContextV === void 0 ? void 0 : _externalListContextV.call(externalListContextValue, item)),
      "aria-posinset": infinite ? posInSet : undefined,
      "aria-setsize": sizeOfSet,
      id: getIdUsingOption(item, groupIndex),
      isActive: isOptionActive(item, groupIndex) && !!descendantManager,
      isSelected: isOptionSelected(item) && allowSelection,
      disabled: item === null || item === void 0 ? void 0 : item.disabled,
      divider: item === null || item === void 0 ? void 0 : item.divider,
      key: (0, _concat.default)(_context6 = "lb-item-".concat(groupIndex, "-")).call(_context6, itemIndex),
      onClick: handleItemClick,
      topAlign: topAlign
    }), !(item !== null && item !== void 0 && item.divider) && ((0, _isFunction.default)(listItemRenderer) ? listItemRenderer(item) : item[listItemRenderer]));
  };
  var classes = classnames(CSS_BLOCK, className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--hide-focus-ring"), hideOuterFocusRing), (0, _concat.default)(_context7 = "".concat(CSS_BLOCK, "--")).call(_context7, orientation), orientation !== 'vertical'), "".concat(CSS_BLOCK, "--has-sticky-labels"), !!stickyLabel));
  var labelClasses = classnames("".concat(CSS_BLOCK, "__label"), externalListContextValue === null || externalListContextValue === void 0 ? void 0 : externalListContextValue.gridLabelClassName, labelProps === null || labelProps === void 0 ? void 0 : labelProps.className, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context8 = "".concat(CSS_BLOCK, "__label--")).call(_context8, size), size !== 'lg'), "".concat(CSS_BLOCK, "__label--sticky"), !!stickyLabel));
  var labelContent = label && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, labelProps, {
    "aria-hidden": "true",
    id: labelId,
    role: "presentation",
    className: labelClasses,
    ref: (0, _reactMergeRefs.default)([labelRef, labelProps === null || labelProps === void 0 ? void 0 : labelProps.ref])
  }), label);
  var _useInfiniteScroll = (0, _reactInfiniteScrollHook.default)({
      loading: false,
      hasNextPage: infinite === null || infinite === void 0 ? void 0 : infinite.hasMore,
      onLoadMore: infinite === null || infinite === void 0 ? void 0 : infinite.onLoadMore,
      rootMargin: '0px 0px 250px 0px'
    }),
    _useInfiniteScroll2 = (0, _slicedToArray2.default)(_useInfiniteScroll, 2),
    infiniteRef = _useInfiniteScroll2[0],
    rootRef = _useInfiniteScroll2[1].rootRef;
  var mergedRef = (0, _reactMergeRefs.default)([ref, listboxRef, rootRef]);
  var loadingIndicatorItem = function loadingIndicatorItem(Component) {
    return (infinite === null || infinite === void 0 ? void 0 : infinite.hasMore) && /*#__PURE__*/_react.default.createElement(Component, {
      "aria-hidden": "true",
      className: classnames(labelClasses, "".concat(CSS_BLOCK, "__label--infinite")),
      ref: infiniteRef,
      role: "presentation"
    }, /*#__PURE__*/_react.default.createElement(_BusyIndicator.default, {
      message: infinite === null || infinite === void 0 ? void 0 : infinite.message,
      size: externalListContextValue !== null && externalListContextValue !== void 0 && externalListContextValue.isGrid ? 'md' : 'sm',
      type: "inline",
      visible: true
    }));
  };
  var renderListbox = function renderListbox() {
    var commonProps = {
      'aria-activedescendant': activeKeys ? getIdFromKeys() : undefined,
      'aria-multiselectable': isMultiSelect ? 'true' : undefined,
      'aria-orientation': orientation,
      className: classes,
      onBlur: handleBlur,
      onFocus: handleFocus,
      onKeyDown: handleOnKeyDown,
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
      },
      ref: mergedRef,
      style: _objectSpread(_objectSpread({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.style), {}, {
        maxHeight: maxHeight
      }),
      tabIndex: externalListContextValue !== null && externalListContextValue !== void 0 && externalListContextValue.disabled ? -1 : 0
    };
    if (isUsingGroups) {
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, commonProps, {
        "aria-labelledby": (0, _listboxUtils.getAriaLabelledBy)({
          ariaLabelledby: ariaLabelledby,
          label: label,
          labelId: labelId
        }),
        role: "listbox"
      }), labelContent, options === null || options === void 0 ? void 0 : (0, _map.default)(options).call(options, function (group, groupIndex) {
        return /*#__PURE__*/_react.default.createElement(_ListboxGroup.default, (0, _extends2.default)({}, groupProps, {
          stickyLabel: stickyLabel,
          labelHeight: labelHeight,
          key: "lb-group-".concat(groupIndex),
          ariaLabelledby: ariaLabelledby,
          label: renderGroupLabel(group),
          labelRef: groupLabelRef
        }), (0, _map.default)(group).call(group, function (item, itemIndex) {
          return renderItem(item, itemIndex, groupIndex);
        }));
      }), loadingIndicatorItem('div'));
    }
    return /*#__PURE__*/_react.default.createElement(_ListboxGroup.default, (0, _extends2.default)({}, otherProps, commonProps, {
      stickyLabel: stickyLabel,
      ariaLabelledby: ariaLabelledby,
      label: label
    }), options === null || options === void 0 ? void 0 : (0, _map.default)(options).call(options, function (item, itemIndex) {
      return renderItem(item, itemIndex, 0);
    }), loadingIndicatorItem('li'));
  };
  var adjustedListContextValue = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, externalListContextValue), listContextValue);
  }, [externalListContextValue, listContextValue]);
  if (isEmpty && noDataContent) {
    return noDataContent;
  }
  return /*#__PURE__*/_react.default.createElement(_ListContext.default.Provider, {
    value: adjustedListContextValue
  }, renderListbox());
});
Listbox.displayName = 'Listbox';
Listbox.propTypes = {
  /** Define the aria-labelledby attribute.  This is used when **Listbox**
   * is used internally by another component and doesn't label itself.
   */
  ariaLabelledby: _propTypes.default.string,
  /** Set to `true` to add bottom borders to list items. */
  bordered: _propTypes.default.bool,
  /** CSS class(es) to add to the element. */
  className: _propTypes.default.string,
  /** Callback function or key used to render the group label for grouped data.
   * the function will be passed the raw option object.
   */
  groupLabelRenderer: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  /** @ignore set by GridListbox */
  groupProps: _propTypes.default.object,
  /** Set to **true** to hide ListBox's focus ring.
   * Focus ring will only be shown on currently focus list item.
  */
  hideOuterFocusRing: _propTypes.default.bool,
  /** Defines the properties for infinite scrolling.
   *
   * `message` (string): Localized text to display while more data is loaded.
   *
   * `hasMore` (bool): Sets whether there are more items to be loaded.
   * Event listeners are removed if set to `false`.
   * This can also be used to disable infinite loading.
   * NOTE: Setting `hasMore` to `true` emits a loading message.
   * Having both `isLoading` and `hasMore` set to `true` will result in multiple loading messages.
   *
   * `onLoadMore`(func): A callback when more items are requested by the user.
  */
  infinite: _propTypes.default.shape({
    message: _propTypes.default.string.isRequired,
    hasMore: _propTypes.default.bool,
    onLoadMore: _propTypes.default.func
  }),
  /** Set to **true** if the listbox is being used as a dropdown list as
   * part of another component.  This will alter keyboard handling.
   */
  ignoreFirstAndLastKeys: _propTypes.default.bool,
  /** Used to identify the unique key for a list item. If a string is used,
   * it identifies the field in the data to use as the key value for the list item.
   * If a function is used, it must return the key value for the list item.
   * The function will be passed the raw option object.
  */
  itemKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  /** Used to identify the text for a list item. If a string is used,
   * it identifies the field in the data to use as the text for the list item.
   * If a function is used, it must return the text for the list item.
   * The function will be passed the raw option object.
   * This is similar to `listItemRenderer`, however this is used more
   * for internal searching and filtering and must return a string rather than
   * a node.
  */
  itemText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  /** Content to display as the label of the **Listbox**. */
  label: _propTypes.default.node,
  /** Additional props to spread to the label container of the **Listbox**. */
  labelProps: _propTypes.default.object,
  /**
   * Used to render content for each list item in the listbox.
   * If a string is used, the value for that key (from `options`)
   * will be shown. If a function is used, it must return a valid node.
   * The function will be passed the row of data (in JSON format).
   */
  listItemRenderer: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  /** Additional props to spread to the Listbox items. */
  listItemProps: _propTypes.default.object,
  /** Fixed height of the **Listbox** (in pixels). */
  maxHeight: _propTypes.default.string,
  /** Defines the component for the “empty” state when `options` is missing or empty.
   * Use **IllustratedMessage**. */
  noDataContent: _propTypes.default.node,
  /** Raw data for the listbox options.
   * Each option needs to have a unique key and a simple string representation of its
   * value defined.  Use `itemKey` and `itemText` to define these.
   * For custom rendering of list items, see `listItemRenderer`.
   * See [formatted list items](#formatted-list-items).
  */
  options: _propTypes.default.array,
  /** Choose whether the options are positioned in a `vertical` (default) or `horizontal
   * orientation. */
  orientation: _propTypes.default.oneOf(ORIENTATION_TYPES),
  /** Step value for `page up` and `page down` keystrokes. This will control how many
   * items are skipped on key press.
   */
  pagingStepValue: _propTypes.default.number,
  /** The key corresponding to the selected option.
   * If an option is disabled, it should not be passed as `selectedKey`. */
  selectedKey: _propTypes.default.string,
  /** The key corresponding to the selected options when using `selectionType="multiSelect"`.
   * If an option is disabled, it should not be included in `selectedKeys`.
   */
  selectedKeys: _propTypes.default.array,
  /** Determines whether focusing an option should automatically select it.
   * Not supported with `selectionType="multiSelect"`.
   */
  selectionFollowsFocus: _propTypes.default.bool,
  /* String representing option selection style:
  * * `'singleSelectMaster'`: used to pick one item with no additional indicator
  * * `'singleSelectLeft'`: used to pick one item, rendering a radio button
  * * `'multiSelect'`: used to pick several items, rendering checkboxes
  */
  selectionType: _propTypes.default.oneOf(LISTBOX_SELECTION_TYPES),
  /**
   * Used to align the selection control (radio, close icon or checkbox).
   */
  selectorPosition: _propTypes.default.oneOf(LISTBOX_SELECTOR_POSITIONS),
  /** Component size. */
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /** Set to `true` to make labels and group labels sticky. Requires a `maxHeight` in
   * vertical orientation.
   */
  stickyLabel: _propTypes.default.bool,
  /** Set to **true** to apply top-align styles to the selection control. */
  topAlign: _propTypes.default.bool,
  /**
   * Callback function for blur events - when the listbox loses focus.
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
   */
  onBlur: _propTypes.default.func,
  /**
   * Callback function for focus events on the listbox.
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
   */
  onFocus: _propTypes.default.func,
  /** Callback function fired when a key is pressed down on an option.
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param selectedOptionKey - selected option's key value
   * @param selectedOption - selected option data object
   */
  onKeyDown: _propTypes.default.func,
  /** Callback function fired when the selected option is changed.
   * It will not trigger if the same selection is selected again and again.
   * Not compatible with selectionType="multiselect".
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param selectedOptionKey - selected option's key value
   * @param selectedOption - selected option data object
   * @param prevSelectedOptionKey - previously selected option's key value
   * @param prevSelectedOption - previously selected option data object
   */
  onChange: _propTypes.default.func,
  /** Callback function fired when any option is selected.
   * It will also trigger if the same selection is selected again and again.
   * Not compatible with selectionType="multiselect".
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param selectedOptionKey - selected option's key value
   * @param selectedOption - selected option data object
   */
  onSelect: _propTypes.default.func,
  /** Callback function fired when an option selection state changes (either selected or
   * deselected). Compatible with selectionType="multiselect" only.
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param selectedOptionKey - selected option's key value
   * @param isSelected - whether the option is now selected or not
   * @param selectedOption - selected option data object
   */
  onSelectionChange: _propTypes.default.func
};
var _default = exports.default = Listbox;